import { render, staticRenderFns } from "./MdfeDistribuicao.vue?vue&type=template&id=90870f8a&scoped=true"
import script from "./MdfeDistribuicao.vue?vue&type=script&lang=js"
export * from "./MdfeDistribuicao.vue?vue&type=script&lang=js"
import style0 from "./MdfeDistribuicao.vue?vue&type=style&index=0&id=90870f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90870f8a",
  null
  
)

export default component.exports